import {useMutation} from '@apollo/react-hooks';

import type {
    BootSnippetDomainSet as BootSnippetDomainSetMutation,
    BootSnippetDomainSetVariables as BootSnippetDomainSetMutationVariables,
    BootSnippetDomainSetInput,
} from 'nutshell-graphql-types';

import SET_BOOT_SNIPPET_DOMAIN from '../mutations/boot-snippet-domain-set.graphql';

export function useSetBootSnippetDomain(): {
    setBootSnippetDomain: (arg1: BootSnippetDomainSetInput) => Promise<any>;
} {
    const [setBootSnippetDomain] = useMutation<
        BootSnippetDomainSetMutation,
        BootSnippetDomainSetMutationVariables
    >(SET_BOOT_SNIPPET_DOMAIN);

    return {
        setBootSnippetDomain: (input: BootSnippetDomainSetInput) =>
            setBootSnippetDomain({
                variables: {input},
            }),
    };
}
